export class Version {
	static avdh = "673db78e5504bc97c2df39e0ceaa6b09"
	static blog_hu = "895a66dea551934c9467c3330dd7d9f3"
	static en = "8993aa16e2ad4ec7347ef3d700f9dadd"
	static hu = "1bc74fa450d6bfc00bdca5d25aa51b8c"
	static it = "48b623b732e9abf7b1e5fc2763b85ba8"
	static languages = "36759b23ead2ba741e8a1de9c3409b84"
}